import { useTranslation } from 'react-i18next'
import { Tooltip } from '../../rapid-ui'
import { AI_GENERATED_LABEL_URL } from './constants'

/**
 * The label image with an editor-only explainer tooltip. The tooltip bubble
 * renders through a portal outside `[data-render-me]`, so it can never leak
 * into the baked PNG.
 */
export function AiGeneratedLabelBadge() {
	const { t } = useTranslation('editor')

	return (
		<Tooltip content={t('simulator.aiGeneratedLabel.tooltip')} className="max-w-64">
			<img
				src={AI_GENERATED_LABEL_URL}
				alt="AI generated"
				className="w-full cursor-help"
			/>
		</Tooltip>
	)
}
